// インポート部分
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
// CSSのインポート
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { speed } from 'jquery';

// DOMContentLoadedイベントを使用して、DOM読み込み完了後に実行
document.addEventListener('DOMContentLoaded', function () {
  const swiperElement = document.querySelector('.top-mv-Swiper');

  // 要素が存在する場合のみ処理を実行
  if (swiperElement) {
    const slides = swiperElement.querySelectorAll('.swiper-slide');

    const toprmvSwiper = new Swiper('.top-mv-Swiper', {
      modules: [EffectFade, Navigation, Pagination, Autoplay],
      slidesPerView: 'auto',
      speed: 1000,
      centeredSlides: true,
      loop: slides.length > 1,
      spaceBetween: 20,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        768: {
          spaceBetween: 40
        }
      }
    });

    // スライドが1枚の場合、ページネーションを非表示
    if (slides.length <= 1) {
      const pagination = document.querySelector('.swiper-pagination');
      if (pagination) {
        pagination.style.display = 'none';
      }
    }
  }
});
